// extracted by mini-css-extract-plugin
module.exports = {"PCComp":"PcComp_PCComp__OksCV"};